import React, { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'
import { cn } from '../../lib/utils'

type NativeInputProps = {
  className?: string
} & Omit<ComponentPropsWithoutRef<'input'>, 'className'>

export const NativeInput = forwardRef<HTMLInputElement, NativeInputProps>(function NativeInput({ className, ...props }, ref) {
  return <input ref={ref} {...props} data-disabled={props.disabled ? 'true' : undefined} className={cn('data-disabled:cursor-not-allowed', className)} />
})
